// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// Component imports
import { Button, Col, Modal, Row, Typography } from 'antd';

// Misc imports
import { NAV_NDES_EDIT, NAV_RELATIVE_NDES_BASIC_DETAILS } from '../../constants';
import replaceUrlParams from '../../utils/misc/replaceUrlParams';
import successImg from '../../assets/images/success.png';

const NdeCreateSuccessModal = (props) => {
  const { visible, setVisible, ndeUuid } = props;
  const navigate = useNavigate();
  const editUrl = replaceUrlParams(NAV_NDES_EDIT + NAV_RELATIVE_NDES_BASIC_DETAILS, { ndeUuid: ndeUuid });

  const navigateToEditPage = () => {
    setVisible(false);
    navigate(editUrl);
  };

  return (
    <Modal
      centered
      visible={visible}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      closable={false}
      afterClose={navigateToEditPage}
      footer={null}
    >
      <Row className="text-center">
        <Col>
          <Col span={24} className="mb-32">
            <img src={successImg} height={130} alt="Success" />
          </Col>

          <Col span={24} className="px-12 mb-32">
            <Typography.Title level={3} className="mb-18">Thank you!</Typography.Title>
            <Typography.Text className="font-weight-300 text-secondary p1-body">Your experience has been submitted. You can edit your entry via the following link:</Typography.Text>
            <br/><br/>
            <Typography.Link copyable className="text-link" onClick={navigateToEditPage}>
              {replaceUrlParams(`${window.location.origin}${NAV_NDES_EDIT + NAV_RELATIVE_NDES_BASIC_DETAILS}`, { ndeUuid: ndeUuid })}
            </Typography.Link>
          </Col>

          <Col span={24}>
            <Button type="primary" size="large" onClick={navigateToEditPage}>
              View your NDE
            </Button>
          </Col>
        </Col>
      </Row>
    </Modal>
  );
};

NdeCreateSuccessModal.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  ndeUuid: PropTypes.string.isRequired
};

export default NdeCreateSuccessModal;
